import { render, staticRenderFns } from "./ExchangeGoods.vue?vue&type=template&id=181f25bc&scoped=true"
import script from "./ExchangeGoods.vue?vue&type=script&lang=js"
export * from "./ExchangeGoods.vue?vue&type=script&lang=js"
import style0 from "./ExchangeGoods.vue?vue&type=style&index=0&id=181f25bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181f25bc",
  null
  
)

export default component.exports